export default __webpack_public_path__ + "static/media/logo-alt.72a03ccc.svg";